module.exports = __webpack_public_path__ + "static/media/jharkhand.c7957937.png";